"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const trans_1 = require("@common/tsutils/trans");
const PreSet_vue_1 = __importDefault(require("./PreSet.vue"));
const PreSetItem_vue_1 = __importDefault(require("./PreSetItem.vue"));
const TabularAnalyticsController_1 = __importDefault(require("../modules/controllers/TabularAnalyticsController"));
let TabularPreSet = class TabularPreSet extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.TABULAR_ANALYTICS_CONTROLLER = TabularAnalyticsController_1.default.getInstance();
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get options() {
        const keys = ['recommendations', 'needs', 'metrics', 'phch_metrics'];
        return keys.map((k) => {
            return {
                id: k,
                label: (0, trans_1.trans)('tabular.configuration.presets.' + k),
                active: (this.active.includes(k)) ? true : false
            };
        });
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TabularPreSet.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 's' })
], TabularPreSet.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], TabularPreSet.prototype, "active", void 0);
TabularPreSet = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { PreSetItem: PreSetItem_vue_1.default, PreSet: PreSet_vue_1.default },
    })
], TabularPreSet);
exports.default = TabularPreSet;
